<template>
  <div class="wg-period" v-click-outside="close">
    <button class="wg-quarter" @click="open = !open">
      {{ selected ? selected.label : 'Select period' }}
      <i class="material-icons">expand_more</i>
    </button>

    <div v-if="open" class="wg-period-menu">
      <div v-for="group in groups" :key="group.title" class="wg-period-group">
        <div class="wg-period-gt">{{ group.title }}</div>
        <button
          v-for="period in group.items"
          :key="period.key"
          class="wg-period-item"
          :class="{ active: selected && selected.key === period.key, disabled: !period.hasData }"
          @click="pick(period)"
        >
          <span>{{ period.label }}</span>
          <span v-if="!period.hasData" class="wg-period-tag">{{ period.note || 'No data' }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WinsPeriodPicker',
  props: {
    months: {
      type: Array,
      default: () => [],
    },
    quarters: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      open: false,
    }
  },
  computed: {
    groups () {
      return [
        { title: 'Monthly', items: this.months },
        { title: 'Quarterly', items: this.quarters },
      ].filter((g) => g.items.length)
    },
  },
  methods: {
    close () {
      this.open = false
    },
    pick (period) {
      // "Periods with no data are listed but disabled."
      if (!period.hasData) return
      this.$emit('select', period)
      this.open = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../Settings/wg-tokens.scss';

.wg-period {
  position: relative;
}

.wg-quarter {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  min-width: 200px;
  background: #fff;
  border: 1px solid $pop-border;
  border-radius: 6px;
  padding: 10px 13px;
  font-size: 0.9rem;
  color: $pop-teal;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;

  .material-icons {
    color: $pop-ink-muted;
    font-size: 1.35rem;
  }
}

.wg-period-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 40;
  min-width: 290px;
  background: #fff;
  border: 1px solid $pop-border;
  border-radius: 10px;
  box-shadow: $shadow-menu;
  padding: 6px;
}

.wg-period-group + .wg-period-group {
  border-top: 1px solid $wg-hairline;
  margin-top: 5px;
  padding-top: 7px;
}

.wg-period-gt {
  font-size: 0.7rem;
  font-weight: 700;
  color: $pop-ink-faint;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 5px 12px;
}

.wg-period-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  background: none;
  border: none;
  text-align: left;
  font-size: 0.85rem;
  color: $pop-teal;
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: $wg-lavender;
  }

  &.active {
    background: $pop-accent-bg;
    color: $pop-accent;
    font-weight: 700;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
}

.wg-period-tag {
  font-size: 0.7rem;
  font-weight: 700;
  color: $pop-ink-faint;
  background: $pop-box-bg;
  padding: 3px 8px;
  border-radius: 30px;
  white-space: nowrap;
}
</style>
